import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9852e04"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "登録", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "再集計", -1))
const _hoisted_5 = {
  class: "col-auto text-center mt-2 mb-1",
  style: {"font-size":"40px"}
}
const _hoisted_6 = {
  id: "corporation-table",
  class: "table table-borderless text-end w-auto ml-auto"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"35%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"65%"} })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "医療法人整理番号", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "法人番号", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "病床・外来管理番号", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "医療機関コード", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  id: "facility-table",
  class: "table table-borderless ml-auto"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"14%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"20%"} }),
  /*#__PURE__*/_createElementVNode("col"),
  /*#__PURE__*/_createElementVNode("col")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "法人名", -1))
const _hoisted_21 = { colspan: "3" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "text-start" }
const _hoisted_24 = {
  class: "text-start",
  colspan: "2"
}
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "text-start" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "役員数（人）", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "text-start" }
const _hoisted_31 = { class: "d-flex align-items-center" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "職員数（人）", -1))
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "text-start" }
const _hoisted_35 = { class: "text-start" }
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "都道府県", -1))
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "text-start" }
const _hoisted_40 = { class: "d-flex align-items-center" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "市区町村", -1))
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "text-start" }
const _hoisted_44 = { class: "d-flex align-items-center" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "町域", -1))
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "text-start" }
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "二次医療圏", -1))
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "row justify-content-center mt-4 mb-4" }
const _hoisted_52 = { class: "d-flex align-items-center col-auto" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2 mb-0" }, "期間", -1))
const _hoisted_54 = ["value"]
const _hoisted_55 = {
  class: "d-flex align-items-center justify-content-between mx-auto",
  style: {"width":"80%"}
}
const _hoisted_56 = { class: "d-flex align-items-center" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "消費税の経理方式", -1))
const _hoisted_58 = ["value"]
const _hoisted_59 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "主たる診療科", -1))
const _hoisted_61 = ["value"]
const _hoisted_62 = ["value"]
const _hoisted_63 = ["value"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "（単位：円）")
], -1))
const _hoisted_65 = {
  id: "keiei-jokyo-table",
  class: "mt-2 mx-auto",
  style: {"width":"80%"}
}
const _hoisted_66 = { class: "table table-bordered" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"65%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"25%"} })
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "科目"),
    /*#__PURE__*/_createElementVNode("th", null, "金額")
  ])
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "医業収益", -1))
const _hoisted_71 = { class: "text-right" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "入院診療収益", -1))
const _hoisted_74 = { class: "text-right" }
const _hoisted_75 = { class: "text-center" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "保険診療収益(患者負担含む)", -1))
const _hoisted_77 = { class: "text-right" }
const _hoisted_78 = { class: "text-center" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "公害等診療収益", -1))
const _hoisted_80 = { class: "text-right" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { class: "text-center" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "室料差額収益", -1))
const _hoisted_84 = { class: "text-right" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "その他の診療収益", -1))
const _hoisted_87 = { class: "text-right" }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "室料差額収益", -1))
const _hoisted_91 = { class: "text-right" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "外来診療収益", -1))
const _hoisted_94 = { class: "text-right" }
const _hoisted_95 = { class: "text-center" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "保険診療収益(患者負担含む)", -1))
const _hoisted_97 = { class: "text-right" }
const _hoisted_98 = { class: "text-center" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "公害等診療収益", -1))
const _hoisted_100 = { class: "text-right" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "その他の診療収益", -1))
const _hoisted_103 = { class: "text-right" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "その他の医業収益", -1))
const _hoisted_106 = { class: "text-right" }
const _hoisted_107 = { class: "text-center" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "うち保健予防活動収益", -1))
const _hoisted_109 = { class: "text-right" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "うち運営費補助金収益", -1))
const _hoisted_112 = { class: "text-right" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "医業費用", -1))
const _hoisted_115 = { class: "text-right" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "材料費", -1))
const _hoisted_118 = { class: "text-right" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "医薬品費", -1))
const _hoisted_121 = { class: "text-right" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "診療材料費、医療消耗器具備品費", -1))
const _hoisted_124 = { class: "text-right" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "給食用材料費", -1))
const _hoisted_127 = { class: "text-right" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "給与費", -1))
const _hoisted_130 = { class: "text-right" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "（うち消費税課税対象費用）", -1))
const _hoisted_133 = { class: "text-right" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "役員報酬", -1))
const _hoisted_136 = { class: "text-right" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "給料", -1))
const _hoisted_139 = { class: "text-right" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "賞与", -1))
const _hoisted_142 = { class: "text-right" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "賞与引当金繰入額", -1))
const _hoisted_145 = { class: "text-right" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "退職給付費用", -1))
const _hoisted_148 = { class: "text-right" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "法定福利費", -1))
const _hoisted_151 = { class: "text-right" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "委託費", -1))
const _hoisted_154 = { class: "text-right" }
const _hoisted_155 = { key: 2 }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "うち給食委託費", -1))
const _hoisted_158 = { class: "text-right" }
const _hoisted_159 = { key: 3 }
const _hoisted_160 = { class: "text-center" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "うち給食委託費", -1))
const _hoisted_162 = { class: "text-right" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "設備関係費", -1))
const _hoisted_165 = { class: "text-right" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "（うち消費税課税対象費用）", -1))
const _hoisted_168 = { class: "text-right" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "うち減価償却費", -1))
const _hoisted_171 = { class: "text-right" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "うち器機賃借料", -1))
const _hoisted_174 = { class: "text-right" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "研究研修費", -1))
const _hoisted_177 = { class: "text-right" }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "（うち消費税課税対象費用）", -1))
const _hoisted_180 = { class: "text-right" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "経費", -1))
const _hoisted_183 = { class: "text-right" }
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "（うち消費税課税対象費用）", -1))
const _hoisted_186 = { class: "text-right" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "うち水道光熱費", -1))
const _hoisted_189 = { class: "text-right" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "控除対象外消費税等負担額", -1))
const _hoisted_192 = { class: "text-right" }
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "本部費配賦額", -1))
const _hoisted_195 = { class: "text-right" }
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "減価償却費", -1))
const _hoisted_198 = { class: "text-right" }
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "器機賃借料", -1))
const _hoisted_201 = { class: "text-right" }
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "その他の医業費用", -1))
const _hoisted_204 = { class: "text-right" }
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "（うち消費税課税対象費用）", -1))
const _hoisted_207 = { class: "text-right" }
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "うち水道光熱費", -1))
const _hoisted_210 = { class: "text-right" }
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "うち控除対象外消費税等負担額", -1))
const _hoisted_213 = { class: "text-right" }
const _hoisted_214 = { class: "text-center" }
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "うち本部費配賦額", -1))
const _hoisted_216 = { class: "text-right" }
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "医業利益（又は医業損失）", -1))
const _hoisted_219 = { class: "text-right" }
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "医業外収益", -1))
const _hoisted_222 = { class: "text-right" }
const _hoisted_223 = { class: "text-center" }
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "うち受取利息及び配当金", -1))
const _hoisted_225 = { class: "text-right" }
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "うち運営費補助金収益", -1))
const _hoisted_228 = { class: "text-right" }
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "うち施設補助金収益", -1))
const _hoisted_231 = { class: "text-right" }
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "医業外費用", -1))
const _hoisted_234 = { class: "text-right" }
const _hoisted_235 = { class: "text-center" }
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "うち支払利息", -1))
const _hoisted_237 = { class: "text-right" }
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "経常利益(又は計上損失)", -1))
const _hoisted_240 = { class: "text-right" }
const _hoisted_241 = { key: 6 }
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "臨時収益", -1))
const _hoisted_244 = { class: "text-right" }
const _hoisted_245 = { key: 7 }
const _hoisted_246 = { class: "text-center" }
const _hoisted_247 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "臨時収益", -1))
const _hoisted_248 = { class: "text-right" }
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "うち運営費補助金収益", -1))
const _hoisted_251 = { class: "text-right" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "うち施設補助金収益", -1))
const _hoisted_254 = { class: "text-right" }
const _hoisted_255 = { key: 8 }
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "臨時費用", -1))
const _hoisted_258 = { class: "text-right" }
const _hoisted_259 = { key: 9 }
const _hoisted_260 = { class: "text-center" }
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "臨時費用", -1))
const _hoisted_262 = { class: "text-right" }
const _hoisted_263 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "税引前当期純利益(又は税引前当期純損失)", -1))
const _hoisted_265 = { class: "text-right" }
const _hoisted_266 = { class: "text-center" }
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "法人税、住民税及び事業税負担額", -1))
const _hoisted_268 = { class: "text-right" }
const _hoisted_269 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "当期純利益", -1))
const _hoisted_271 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_input_kin = _resolveComponent("input-kin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_loading_button, {
        color: "primary",
        onClick: _ctx.onClickedRegister,
        class: "mr-2"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_loading_button, {
        color: "primary",
        onClick: _ctx.onClickedRecalculate,
        class: "mr-5"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("p", _hoisted_5, "経営状況に関する情報（" + _toDisplayString(_ctx.clinicOrHospitalLabel) + "）", 1),
    _createElementVNode("table", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _hoisted_8,
          _createElementVNode("td", null, [
            _createElementVNode("textarea", {
              class: "form-control-sm text-start",
              style: {"width":"100%","resize":"none"},
              value: _ctx.corporationInfo?.medicalCorporationNumber,
              disabled: ""
            }, null, 8, _hoisted_9)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_10,
          _createElementVNode("td", null, [
            _createElementVNode("textarea", {
              class: "form-control-sm text-start",
              style: {"width":"100%","resize":"none"},
              value: _ctx.corporationInfo?.corporationNumber,
              disabled: ""
            }, null, 8, _hoisted_11)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_12,
          _createElementVNode("td", null, [
            _createElementVNode("textarea", {
              class: "form-control-sm text-start",
              style: {"width":"25%","resize":"none"},
              value: _ctx.facilityInfo?.hasBedOutpatientMgmtNumber,
              disabled: ""
            }, null, 8, _hoisted_13),
            _createElementVNode("textarea", {
              class: "form-control-sm text-start ml-2 ml-auto",
              style: {"width":"75%","resize":"none"},
              value: _ctx.facilityInfo?.bedOutpatientMgmtNumber,
              disabled: ""
            }, null, 8, _hoisted_14)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_15,
          _createElementVNode("td", null, [
            _createElementVNode("textarea", {
              class: "form-control-sm text-start",
              style: {"width":"25%","resize":"none"},
              value: _ctx.facilityInfo?.hasMedicalInstitutionCode,
              disabled: ""
            }, null, 8, _hoisted_16),
            _createElementVNode("textarea", {
              class: "form-control-sm text-start ml-2 ml-auto",
              style: {"width":"75%","resize":"none"},
              value: _ctx.facilityInfo?.medicalInstitutionCode,
              disabled: ""
            }, null, 8, _hoisted_17)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("table", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_20,
            _createElementVNode("td", _hoisted_21, [
              _createElementVNode("textarea", {
                class: "form-control-sm text-start",
                style: {"width":"100%","resize":"none"},
                value: _ctx.corporationInfo?.corporateName,
                disabled: ""
              }, null, 8, _hoisted_22)
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.clinicOrHospitalLabel) + "名", 1),
            _createElementVNode("td", _hoisted_24, [
              _createElementVNode("textarea", {
                class: "form-control-sm text-start",
                style: {"width":"100%","resize":"none"},
                value: _ctx.facilityInfo?.hospitalClinicName,
                disabled: ""
              }, null, 8, _hoisted_25)
            ]),
            _createElementVNode("td", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("textarea", {
                  class: "form-control-sm text-start",
                  style: {"width":"100%","resize":"none"},
                  value: _ctx.facilityInfo?.executiveCount,
                  disabled: ""
                }, null, 8, _hoisted_29)
              ])
            ]),
            _createElementVNode("td", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("textarea", {
                  class: "form-control-sm text-start",
                  style: {"width":"100%","resize":"none"},
                  value: _ctx.facilityInfo?.staffCount,
                  disabled: ""
                }, null, 8, _hoisted_33)
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.clinicOrHospitalLabel) + "所在地", 1),
            _createElementVNode("td", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("textarea", {
                  class: "form-control-sm text-start",
                  style: {"width":"100%","resize":"none"},
                  value: _ctx.facilityInfo?.prefecture,
                  disabled: ""
                }, null, 8, _hoisted_38)
              ])
            ]),
            _createElementVNode("td", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("textarea", {
                  class: "form-control-sm text-start",
                  style: {"width":"100%","resize":"none"},
                  value: _ctx.facilityInfo?.municipality,
                  disabled: ""
                }, null, 8, _hoisted_42)
              ])
            ]),
            _createElementVNode("td", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("textarea", {
                  class: "form-control-sm text-start",
                  style: {"width":"100%","resize":"none"},
                  value: _ctx.facilityInfo?.townArea,
                  disabled: ""
                }, null, 8, _hoisted_46)
              ])
            ]),
            _createElementVNode("td", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("textarea", {
                  class: "form-control-sm text-start",
                  style: {"width":"100%","resize":"none"},
                  value: _ctx.facilityInfo?.secondaryMedicalArea,
                  disabled: ""
                }, null, 8, _hoisted_50)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _hoisted_53,
        _createElementVNode("textarea", {
          class: "form-control-sm text-center",
          style: {"width":"200px","resize":"none"},
          value: _ctx.startDate + ' ～ ' + _ctx.endDate,
          disabled: ""
        }, null, 8, _hoisted_54)
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _hoisted_57,
        _createElementVNode("textarea", {
          class: "form-control-sm text-start",
          style: {"width":"200px","resize":"none"},
          value: _ctx.facilityInfo?.taxAccountingMethod,
          disabled: ""
        }, null, 8, _hoisted_58)
      ]),
      (_ctx.isClinicKbn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
            _hoisted_60,
            _createElementVNode("textarea", {
              class: "form-control-sm text-start",
              style: {"width":"150px","resize":"none"},
              value: _ctx.facilityInfo?.primarySpecialty1,
              disabled: ""
            }, null, 8, _hoisted_61),
            _createElementVNode("textarea", {
              class: "form-control-sm text-start",
              style: {"width":"150px","resize":"none"},
              value: _ctx.facilityInfo?.primarySpecialty2,
              disabled: ""
            }, null, 8, _hoisted_62),
            _createElementVNode("textarea", {
              class: "form-control-sm text-start",
              style: {"width":"150px","resize":"none"},
              value: _ctx.facilityInfo?.primarySpecialty3,
              disabled: ""
            }, null, 8, _hoisted_63)
          ]))
        : _createCommentVNode("", true),
      _hoisted_64
    ]),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("table", _hoisted_66, [
        _hoisted_67,
        _hoisted_68,
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_69,
            _hoisted_70,
            _createElementVNode("td", _hoisted_71, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.IgyoShueki.value.kin,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.kmkMap.IgyoShueki.value.kin) = $event)),
                "allow-blank": true,
                min: 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_72,
            _hoisted_73,
            _createElementVNode("td", _hoisted_74, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.NyuinShueki.value.kin,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.kmkMap.NyuinShueki.value.kin) = $event)),
                "allow-blank": true,
                min: 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_75, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkboxStates.NyuinShuekiHoken.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.NyuinShuekiHoken.isChecked]
              ])
            ]),
            _hoisted_76,
            _createElementVNode("td", _hoisted_77, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.NyuinShuekiHoken.value.kin,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.kmkMap.NyuinShuekiHoken.value.kin) = $event)),
                "allow-blank": true,
                disabled: _ctx.checkboxStates.NyuinShuekiHoken.isDisabled
              }, null, 8, ["modelValue", "disabled"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_78, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.checkboxStates.NyuinShuekiKogai.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.NyuinShuekiKogai.isChecked]
              ])
            ]),
            _hoisted_79,
            _createElementVNode("td", _hoisted_80, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.NyuinShuekiKogai.value.kin,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.kmkMap.NyuinShuekiKogai.value.kin) = $event)),
                "allow-blank": true,
                disabled: _ctx.checkboxStates.NyuinShuekiKogai.isDisabled
              }, null, 8, ["modelValue", "disabled"])
            ])
          ]),
          (_ctx.isClinicKbn)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_81, [
                _createElementVNode("td", _hoisted_82, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkboxStates.ShitsuryoShueki.isChecked) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.checkboxStates.ShitsuryoShueki.isChecked]
                  ])
                ]),
                _hoisted_83,
                _createElementVNode("td", _hoisted_84, [
                  _createVNode(_component_input_kin, {
                    modelValue: _ctx.kmkMap.ShitsuryoShueki.value.kin,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.kmkMap.ShitsuryoShueki.value.kin) = $event)),
                    "allow-blank": true,
                    min: 0,
                    disabled: _ctx.checkboxStates.ShitsuryoShueki.isDisabled
                  }, null, 8, ["modelValue", "disabled"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tr", null, [
            _hoisted_85,
            _hoisted_86,
            _createElementVNode("td", _hoisted_87, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.NyuinShuekiOther.value.kin,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.kmkMap.NyuinShuekiOther.value.kin) = $event)),
                "allow-blank": false,
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          (_ctx.isHospitalKbn)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_88, [
                _hoisted_89,
                _hoisted_90,
                _createElementVNode("td", _hoisted_91, [
                  _createVNode(_component_input_kin, {
                    modelValue: _ctx.kmkMap.ShitsuryoShueki.value.kin,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.kmkMap.ShitsuryoShueki.value.kin) = $event)),
                    "allow-blank": true,
                    min: 0
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tr", null, [
            _hoisted_92,
            _hoisted_93,
            _createElementVNode("td", _hoisted_94, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.GairaiShueki.value.kin,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.kmkMap.GairaiShueki.value.kin) = $event)),
                "allow-blank": true,
                min: 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_95, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.checkboxStates.GairaiShuekiHoken.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.GairaiShuekiHoken.isChecked]
              ])
            ]),
            _hoisted_96,
            _createElementVNode("td", _hoisted_97, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.GairaiShuekiHoken.value.kin,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.kmkMap.GairaiShuekiHoken.value.kin) = $event)),
                "allow-blank": true,
                disabled: _ctx.checkboxStates.GairaiShuekiHoken.isDisabled
              }, null, 8, ["modelValue", "disabled"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_98, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.checkboxStates.GairaiShuekiKogai.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.GairaiShuekiKogai.isChecked]
              ])
            ]),
            _hoisted_99,
            _createElementVNode("td", _hoisted_100, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.GairaiShuekiKogai.value.kin,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.kmkMap.GairaiShuekiKogai.value.kin) = $event)),
                "allow-blank": true,
                disabled: _ctx.checkboxStates.GairaiShuekiKogai.isDisabled
              }, null, 8, ["modelValue", "disabled"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_101,
            _hoisted_102,
            _createElementVNode("td", _hoisted_103, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.GairaiShuekiOther.value.kin,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.kmkMap.GairaiShuekiOther.value.kin) = $event)),
                "allow-blank": false,
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_104,
            _hoisted_105,
            _createElementVNode("td", _hoisted_106, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.OtherShueki.value.kin,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.kmkMap.OtherShueki.value.kin) = $event)),
                "allow-blank": false,
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_107, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.checkboxStates.OtherShuekiHoken.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.OtherShuekiHoken.isChecked]
              ])
            ]),
            _hoisted_108,
            _createElementVNode("td", _hoisted_109, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.OtherShuekiHoken.value.kin,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.kmkMap.OtherShuekiHoken.value.kin) = $event)),
                "allow-blank": true,
                disabled: _ctx.checkboxStates.OtherShuekiHoken.isDisabled
              }, null, 8, ["modelValue", "disabled"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_110,
            _hoisted_111,
            _createElementVNode("td", _hoisted_112, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.OtherShuekiUnei.value.kin,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.kmkMap.OtherShuekiUnei.value.kin) = $event)),
                "allow-blank": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_113,
            _hoisted_114,
            _createElementVNode("td", _hoisted_115, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.IgyoHiyo.value.kin,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.kmkMap.IgyoHiyo.value.kin) = $event)),
                "allow-blank": true,
                min: 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_116,
            _hoisted_117,
            _createElementVNode("td", _hoisted_118, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.Zairyohi.value.kin,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.kmkMap.Zairyohi.value.kin) = $event)),
                "allow-blank": false,
                disabled: "",
                min: 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_119,
            _hoisted_120,
            _createElementVNode("td", _hoisted_121, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.Iyakuhinhi.value.kin,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.kmkMap.Iyakuhinhi.value.kin) = $event)),
                "allow-blank": true,
                min: 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_122,
            _hoisted_123,
            _createElementVNode("td", _hoisted_124, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.ShinryoZairyohi.value.kin,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.kmkMap.ShinryoZairyohi.value.kin) = $event)),
                "allow-blank": true,
                min: 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_125,
            _hoisted_126,
            _createElementVNode("td", _hoisted_127, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.KyushokuZairyohi.value.kin,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.kmkMap.KyushokuZairyohi.value.kin) = $event)),
                "allow-blank": true,
                min: 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_128,
            _hoisted_129,
            _createElementVNode("td", _hoisted_130, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.Kyuyohi.value.kin,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.kmkMap.Kyuyohi.value.kin) = $event)),
                "allow-blank": false,
                disabled: "",
                min: 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_131,
            _hoisted_132,
            _createElementVNode("td", _hoisted_133, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.KyuyohiShohizei.value.kin,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.kmkMap.KyuyohiShohizei.value.kin) = $event)),
                "allow-blank": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_134,
            _hoisted_135,
            _createElementVNode("td", _hoisted_136, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.YakuinHoshu.value.kin,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.kmkMap.YakuinHoshu.value.kin) = $event)),
                "allow-blank": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_137,
            _hoisted_138,
            _createElementVNode("td", _hoisted_139, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.Kyuryo.value.kin,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.kmkMap.Kyuryo.value.kin) = $event)),
                "allow-blank": true,
                min: 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_140,
            _hoisted_141,
            _createElementVNode("td", _hoisted_142, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.Shoyo.value.kin,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.kmkMap.Shoyo.value.kin) = $event)),
                "allow-blank": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_143,
            _hoisted_144,
            _createElementVNode("td", _hoisted_145, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.ShoyoHikiatekin.value.kin,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.kmkMap.ShoyoHikiatekin.value.kin) = $event)),
                "allow-blank": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_146,
            _hoisted_147,
            _createElementVNode("td", _hoisted_148, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.TaishokuKyuhuHiyo.value.kin,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.kmkMap.TaishokuKyuhuHiyo.value.kin) = $event)),
                "allow-blank": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_149,
            _hoisted_150,
            _createElementVNode("td", _hoisted_151, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.HoteiFukurihi.value.kin,
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.kmkMap.HoteiFukurihi.value.kin) = $event)),
                "allow-blank": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_152,
            _hoisted_153,
            _createElementVNode("td", _hoisted_154, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.Itakuhi.value.kin,
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.kmkMap.Itakuhi.value.kin) = $event)),
                "allow-blank": true,
                min: 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          (_ctx.isHospitalKbn)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_155, [
                _hoisted_156,
                _hoisted_157,
                _createElementVNode("td", _hoisted_158, [
                  _createVNode(_component_input_kin, {
                    modelValue: _ctx.kmkMap.KyushokuItakuhi.value.kin,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.kmkMap.KyushokuItakuhi.value.kin) = $event)),
                    "allow-blank": true,
                    min: 0
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isClinicKbn)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_159, [
                _createElementVNode("td", _hoisted_160, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.checkboxStates.KyushokuItakuhi.isChecked) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.checkboxStates.KyushokuItakuhi.isChecked]
                  ])
                ]),
                _hoisted_161,
                _createElementVNode("td", _hoisted_162, [
                  _createVNode(_component_input_kin, {
                    modelValue: _ctx.kmkMap.KyushokuItakuhi.value.kin,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.kmkMap.KyushokuItakuhi.value.kin) = $event)),
                    "allow-blank": true,
                    min: 0,
                    disabled: _ctx.checkboxStates.KyushokuItakuhi.isDisabled
                  }, null, 8, ["modelValue", "disabled"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isHospitalKbn)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createElementVNode("tr", null, [
                  _hoisted_163,
                  _hoisted_164,
                  _createElementVNode("td", _hoisted_165, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.SetsubiKankeihi.value.kin,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.kmkMap.SetsubiKankeihi.value.kin) = $event)),
                      "allow-blank": false,
                      min: 0
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_166,
                  _hoisted_167,
                  _createElementVNode("td", _hoisted_168, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.SetsubiKankeihiShohizei.value.kin,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.kmkMap.SetsubiKankeihiShohizei.value.kin) = $event)),
                      "allow-blank": true
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_169,
                  _hoisted_170,
                  _createElementVNode("td", _hoisted_171, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.GenkaShokyakuhi.value.kin,
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.kmkMap.GenkaShokyakuhi.value.kin) = $event)),
                      "allow-blank": true,
                      min: 0
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_172,
                  _hoisted_173,
                  _createElementVNode("td", _hoisted_174, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.KikiChinshakuryo.value.kin,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.kmkMap.KikiChinshakuryo.value.kin) = $event)),
                      "allow-blank": true,
                      min: 0
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_175,
                  _hoisted_176,
                  _createElementVNode("td", _hoisted_177, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.KenkyuKenshuhi.value.kin,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.kmkMap.KenkyuKenshuhi.value.kin) = $event)),
                      "allow-blank": true,
                      min: 0
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_178,
                  _hoisted_179,
                  _createElementVNode("td", _hoisted_180, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.KenkyuKenshuhiShohizei.value.kin,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.kmkMap.KenkyuKenshuhiShohizei.value.kin) = $event)),
                      "allow-blank": true
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_181,
                  _hoisted_182,
                  _createElementVNode("td", _hoisted_183, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.Keihi.value.kin,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.kmkMap.Keihi.value.kin) = $event)),
                      "allow-blank": true,
                      min: 0
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_184,
                  _hoisted_185,
                  _createElementVNode("td", _hoisted_186, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.KeihiShohizei.value.kin,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.kmkMap.KeihiShohizei.value.kin) = $event)),
                      "allow-blank": true
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_187,
                  _hoisted_188,
                  _createElementVNode("td", _hoisted_189, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.SuidoKonetsuhi.value.kin,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.kmkMap.SuidoKonetsuhi.value.kin) = $event)),
                      "allow-blank": true,
                      min: 0
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_190,
                  _hoisted_191,
                  _createElementVNode("td", _hoisted_192, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.KojoShohizeiFutan.value.kin,
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.kmkMap.KojoShohizeiFutan.value.kin) = $event)),
                      "allow-blank": true
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_193,
                  _hoisted_194,
                  _createElementVNode("td", _hoisted_195, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.HonbuhiHaifu.value.kin,
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.kmkMap.HonbuhiHaifu.value.kin) = $event)),
                      "allow-blank": true,
                      min: 0
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.isClinicKbn)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _createElementVNode("tr", null, [
                  _hoisted_196,
                  _hoisted_197,
                  _createElementVNode("td", _hoisted_198, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.GenkaShokyakuhi.value.kin,
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.kmkMap.GenkaShokyakuhi.value.kin) = $event)),
                      "allow-blank": true,
                      min: 0
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_199,
                  _hoisted_200,
                  _createElementVNode("td", _hoisted_201, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.KikiChinshakuryo.value.kin,
                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.kmkMap.KikiChinshakuryo.value.kin) = $event)),
                      "allow-blank": true,
                      min: 0
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_202,
                  _hoisted_203,
                  _createElementVNode("td", _hoisted_204, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.OtherIgyoHiyo.value.kin,
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.kmkMap.OtherIgyoHiyo.value.kin) = $event)),
                      "allow-blank": true,
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_205,
                  _hoisted_206,
                  _createElementVNode("td", _hoisted_207, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.OtherIgyoHiyoShohizei.value.kin,
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.kmkMap.OtherIgyoHiyoShohizei.value.kin) = $event)),
                      "allow-blank": true
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_208,
                  _hoisted_209,
                  _createElementVNode("td", _hoisted_210, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.SuidoKonetsuhi.value.kin,
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.kmkMap.SuidoKonetsuhi.value.kin) = $event)),
                      "allow-blank": true,
                      min: 0
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_211,
                  _hoisted_212,
                  _createElementVNode("td", _hoisted_213, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.KojoShohizeiFutan.value.kin,
                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.kmkMap.KojoShohizeiFutan.value.kin) = $event)),
                      "allow-blank": true
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_214, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.checkboxStates.HonbuhiHaifu.isChecked) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.checkboxStates.HonbuhiHaifu.isChecked]
                    ])
                  ]),
                  _hoisted_215,
                  _createElementVNode("td", _hoisted_216, [
                    _createVNode(_component_input_kin, {
                      modelValue: _ctx.kmkMap.HonbuhiHaifu.value.kin,
                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.kmkMap.HonbuhiHaifu.value.kin) = $event)),
                      "allow-blank": true,
                      min: 0,
                      disabled: _ctx.checkboxStates.HonbuhiHaifu.isDisabled
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("tr", null, [
            _hoisted_217,
            _hoisted_218,
            _createElementVNode("td", _hoisted_219, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.IgyoRieki.value.kin,
                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.kmkMap.IgyoRieki.value.kin) = $event)),
                "allow-blank": false,
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_220,
            _hoisted_221,
            _createElementVNode("td", _hoisted_222, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.IgyogaiShueki.value.kin,
                "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.kmkMap.IgyogaiShueki.value.kin) = $event)),
                "allow-blank": true,
                min: 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_223, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.checkboxStates.IgyogaiShuekiUketori.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.IgyogaiShuekiUketori.isChecked]
              ])
            ]),
            _hoisted_224,
            _createElementVNode("td", _hoisted_225, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.IgyogaiShuekiUketori.value.kin,
                "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.kmkMap.IgyogaiShuekiUketori.value.kin) = $event)),
                "allow-blank": true,
                disabled: _ctx.checkboxStates.IgyogaiShuekiUketori.isDisabled
              }, null, 8, ["modelValue", "disabled"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_226,
            _hoisted_227,
            _createElementVNode("td", _hoisted_228, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.IgyogaiShuekiUnei.value.kin,
                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.kmkMap.IgyogaiShuekiUnei.value.kin) = $event)),
                "allow-blank": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_229,
            _hoisted_230,
            _createElementVNode("td", _hoisted_231, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.IgyogaiShuekiShisetsu.value.kin,
                "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.kmkMap.IgyogaiShuekiShisetsu.value.kin) = $event)),
                "allow-blank": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_232,
            _hoisted_233,
            _createElementVNode("td", _hoisted_234, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.IgyogaiHiyo.value.kin,
                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.kmkMap.IgyogaiHiyo.value.kin) = $event)),
                "allow-blank": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_235, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.checkboxStates.ShiharaiRisoku.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.ShiharaiRisoku.isChecked]
              ])
            ]),
            _hoisted_236,
            _createElementVNode("td", _hoisted_237, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.ShiharaiRisoku.value.kin,
                "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.kmkMap.ShiharaiRisoku.value.kin) = $event)),
                "allow-blank": true,
                min: 0,
                disabled: _ctx.checkboxStates.ShiharaiRisoku.isDisabled
              }, null, 8, ["modelValue", "disabled"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_238,
            _hoisted_239,
            _createElementVNode("td", _hoisted_240, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.KeijoRieki.value.kin,
                "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.kmkMap.KeijoRieki.value.kin) = $event)),
                "allow-blank": false,
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          (_ctx.isHospitalKbn)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_241, [
                _hoisted_242,
                _hoisted_243,
                _createElementVNode("td", _hoisted_244, [
                  _createVNode(_component_input_kin, {
                    modelValue: _ctx.kmkMap.RinjiShueki.value.kin,
                    "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.kmkMap.RinjiShueki.value.kin) = $event)),
                    "allow-blank": true
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isClinicKbn)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_245, [
                _createElementVNode("td", _hoisted_246, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.checkboxStates.RinjiShueki.isChecked) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.checkboxStates.RinjiShueki.isChecked]
                  ])
                ]),
                _hoisted_247,
                _createElementVNode("td", _hoisted_248, [
                  _createVNode(_component_input_kin, {
                    modelValue: _ctx.kmkMap.RinjiShueki.value.kin,
                    "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.kmkMap.RinjiShueki.value.kin) = $event)),
                    "allow-blank": true,
                    min: 0,
                    disabled: _ctx.checkboxStates.RinjiShueki.isDisabled
                  }, null, 8, ["modelValue", "disabled"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tr", null, [
            _hoisted_249,
            _hoisted_250,
            _createElementVNode("td", _hoisted_251, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.RinjiShuekiUnei.value.kin,
                "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.kmkMap.RinjiShuekiUnei.value.kin) = $event)),
                "allow-blank": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_252,
            _hoisted_253,
            _createElementVNode("td", _hoisted_254, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.RinjiShuekiShisetsu.value.kin,
                "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.kmkMap.RinjiShuekiShisetsu.value.kin) = $event)),
                "allow-blank": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          (_ctx.isHospitalKbn)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_255, [
                _hoisted_256,
                _hoisted_257,
                _createElementVNode("td", _hoisted_258, [
                  _createVNode(_component_input_kin, {
                    modelValue: _ctx.kmkMap.RinjiHiyo.value.kin,
                    "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.kmkMap.RinjiHiyo.value.kin) = $event)),
                    "allow-blank": true
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isClinicKbn)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_259, [
                _createElementVNode("td", _hoisted_260, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.checkboxStates.RinjiHiyo.isChecked) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.checkboxStates.RinjiHiyo.isChecked]
                  ])
                ]),
                _hoisted_261,
                _createElementVNode("td", _hoisted_262, [
                  _createVNode(_component_input_kin, {
                    modelValue: _ctx.kmkMap.RinjiHiyo.value.kin,
                    "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.kmkMap.RinjiHiyo.value.kin) = $event)),
                    "allow-blank": true,
                    min: 0,
                    disabled: _ctx.checkboxStates.RinjiHiyo.isDisabled
                  }, null, 8, ["modelValue", "disabled"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tr", null, [
            _hoisted_263,
            _hoisted_264,
            _createElementVNode("td", _hoisted_265, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.ZeibikimaeToukiJunrieki.value.kin,
                "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.kmkMap.ZeibikimaeToukiJunrieki.value.kin) = $event)),
                "allow-blank": false,
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_266, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.checkboxStates.HojinJuminFutan.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.HojinJuminFutan.isChecked]
              ])
            ]),
            _hoisted_267,
            _createElementVNode("td", _hoisted_268, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.HojinJuminFutan.value.kin,
                "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.kmkMap.HojinJuminFutan.value.kin) = $event)),
                "allow-blank": true,
                disabled: _ctx.checkboxStates.HojinJuminFutan.isDisabled
              }, null, 8, ["modelValue", "disabled"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_269,
            _hoisted_270,
            _createElementVNode("td", _hoisted_271, [
              _createVNode(_component_input_kin, {
                modelValue: _ctx.kmkMap.ToukiJunrieki.value.kin,
                "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.kmkMap.ToukiJunrieki.value.kin) = $event)),
                "allow-blank": false,
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}